import i18n from '../../i18n';

export const getCoreLocale = (lang) => {
    const currentLang = (lang || i18n?.resolvedLanguage || i18n?.language || localStorage.getItem('i18nextLng') || 'es').toLowerCase();
    if (currentLang.startsWith('en')) {
        return 'en';
    }
    return 'es-MX';
};
